module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/pricing.9d77b4b6.svg";